<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { usePortalStore } from '@/store/portal'
import AppIcon from '@/components/portal/AppIcon.vue'
import ProfilePage from './ProfilePage.vue'
import SecurityPage from './SecurityPage.vue'
// 나의강의실 > 개인정보변경. 현재 페이지(aria-current=page)는 옆 메뉴의 '개인정보변경' 하나이고, 탭은 그 안의 현재 항목(aria-current=true)으로 표시한다.
// 계정 화면(/account/profile·/account/security)의 기능을 나의강의실 틀 안에서 그대로 쓴다.
const portal = usePortalStore(), route = useRoute()
const menu = computed(() => portal.menus.find(item => item.to === '/my') || { children: [] })
const tab = computed(() => route.query.tab === 'security' ? 'security' : 'profile')
useHead({ title: '개인정보변경 · TECHEDU' })
</script>
<template>
  <section class="portal-section portal-info"><div class="portal-container"><div class="portal-info-grid">
    <aside class="portal-sidebar"><h2>나의강의실</h2><nav aria-label="하위 메뉴"><NuxtLink v-for="item in menu.children" :key="item.to" :to="item.to" :aria-current="route.path === item.to ? 'page' : undefined">{{ item.title }}<AppIcon name="chevronRight" :size="14" /></NuxtLink></nav></aside>
    <div class="portal-info-content my-profile">
      <nav class="portal-breadcrumb" aria-label="현재 위치"><NuxtLink to="/">홈</NuxtLink><span aria-hidden="true">›</span><span>나의강의실</span><span aria-hidden="true">›</span><span>개인정보변경</span></nav>
      <h1>개인정보변경</h1>
      <nav class="my-profile-tabs" aria-label="개인정보변경 메뉴">
        <NuxtLink to="/my/profile" :aria-current="tab === 'profile' ? 'true' : undefined">내 정보 변경</NuxtLink>
        <NuxtLink :to="{ path: '/my/profile', query: { tab: 'security' } }" :aria-current="tab === 'security' ? 'true' : undefined">비밀번호·보안 설정</NuxtLink>
      </nav>
      <ProfilePage v-if="tab === 'profile'" embedded />
      <SecurityPage v-else embedded />
    </div>
  </div></div></section>
</template>
<style scoped>
.my-profile-tabs{display:flex;flex-wrap:wrap;gap:0;margin:0 0 28px;border-bottom:2px solid #3157dd}
.my-profile-tabs a{min-width:0;padding:12px 26px;border:1px solid #dcdfe6;border-bottom:0;margin-right:-1px;background:#f7f7f7;color:#555;font-size:15px;font-weight:600;text-align:center}
.my-profile-tabs a[aria-current="true"]{background:#3157dd;border-color:#3157dd;color:#fff}
.my-profile :deep(.page-heading h2){margin:0 0 8px;font-size:22px}
@media(max-width:640px){.my-profile-tabs a{flex:1 1 0;padding:10px 8px;font-size:13px}}
</style>
